/* AlarmVideo — mobile header + filter dropdown. Loaded (deferred) after av.js,
   so its DOMContentLoaded handler and ResizeObserver run after av.js's and win
   the --av-header-h variable. */
(function () {
  'use strict';

  var PHONE = '(max-width: 760px)';   /* same breakpoint as av.css .av-header__bar wrap */
  var TABLET = '(max-width: 900px)';  /* same breakpoint as the filter sidebar going static */

  /* 4. Sticky header on phones: only the search field + category nav stay
        pinned. #header-group keeps position:sticky (av.css), but gets a
        negative top equal to the height of the rows above the search field
        (top bar, logo, buttons), so those scroll away and the rest sticks.
        --av-header-h (used by scroll-margin and the desktop filter sidebar)
        is set to the part that actually stays visible. */
  function initMobileSticky() {
    var header = document.getElementById('header-group');
    var search = header && header.querySelector('.av-search');
    if (!header || !search) return;
    var mq = window.matchMedia(PHONE);

    function apply() {
      var box = header.getBoundingClientRect();
      var full = box.height;
      if (mq.matches) {
        var offset = Math.max(0, Math.round(search.getBoundingClientRect().top - box.top));
        header.style.top = (-offset) + 'px';
        document.documentElement.style.setProperty('--av-header-h', (full - offset) + 'px');
      } else {
        header.style.top = '';
        document.documentElement.style.setProperty('--av-header-h', full + 'px');
      }
    }

    apply();
    if (window.ResizeObserver) new ResizeObserver(apply).observe(header);
    window.addEventListener('resize', apply);
    window.addEventListener('load', apply);
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  /* 3. Filters dropdown on phones/tablets: tap the "Filters" head to open or
        close the list. av.js replaces the whole collection root after every
        filter change, so the open state is kept here and re-applied. */
  function initFilterToggle() {
    var open = false;

    function apply() {
      var sb = document.querySelector('.av-filters-sidebar');
      if (sb) sb.classList.toggle('is-open', open);
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var head = t.closest('.av-filters-sidebar__head');
      if (!head || t.closest('a')) return;             /* "Wissen" link keeps working */
      if (!window.matchMedia(TABLET).matches) return;  /* desktop sidebar is always open */
      open = !open;
      apply();
    });

    if (window.MutationObserver) {
      new MutationObserver(function () { if (open) apply(); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  /* 5. "Menu" dropdown on phones: the toggle opens/closes the category list.
        Closing also folds any open category panel (av.js keeps those open). */
  function initMenuToggle() {
    var wrap = document.querySelector('[data-av-nav]');
    var btn = wrap && wrap.querySelector('[data-av-nav-toggle]');
    if (!wrap || !btn) return;

    function set(open) {
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) {
        wrap.querySelectorAll('[data-av-nav-item].is-open').forEach(function (b) {
          b.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false');
        });
        wrap.querySelectorAll('[data-av-nav-panel]').forEach(function (p) { p.hidden = true; });
        var scrim = wrap.querySelector('[data-av-nav-scrim]');
        if (scrim) scrim.hidden = true;
      }
    }

    btn.addEventListener('click', function () { set(!wrap.classList.contains('is-open')); });
    wrap.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a');
      if (a && window.matchMedia(PHONE).matches) set(false);
    });
    var mq = window.matchMedia(PHONE);
    if (mq.addEventListener) mq.addEventListener('change', function () { if (!mq.matches) set(false); });
  }

  /* 6. Phones (owner 2026-10-12): the opened category panel appears directly under
        the tapped category instead of at the bottom of the whole list. On desktop the
        panels stay at the end of the nav wrapper (dropdown). */
  function initNavPanelPlacement() {
    var wrap = document.querySelector('[data-av-nav]');
    if (!wrap) return;
    var mq = window.matchMedia(PHONE);

    function place(btn) {
      var panel = wrap.querySelector('[data-av-nav-panel="' + btn.getAttribute('data-av-nav-item') + '"]');
      if (!panel) return;
      if (mq.matches) {
        if (btn.nextElementSibling !== panel) btn.insertAdjacentElement('afterend', panel);
        panel.style.marginLeft = panel.style.marginRight = 'calc(var(--av-pad) * -1)';
      } else {
        if (panel.parentNode !== wrap) wrap.appendChild(panel);
        panel.style.marginLeft = panel.style.marginRight = '';
      }
    }
    function all() { wrap.querySelectorAll('[data-av-nav-item]').forEach(place); }

    wrap.querySelectorAll('[data-av-nav-item]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        place(btn);
        if (mq.matches && btn.classList.contains('is-open') && btn.scrollIntoView) {
          setTimeout(function () { btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 50);
        }
      });
    });
    all();
    if (mq.addEventListener) mq.addEventListener('change', all);
  }

  /* 7. Levertijd 1-2 weken (owner 2026-10-12): producten met de tag "levertijd-1-2-weken"
        (voorraadklasse A bij de leverancier) tonen op de productpagina en in de winkelwagen een
        duidelijke levertijdmelding. De tags komen uit /products/<handle>.js. */
  function initLevertijd() {
    var TAG = 'levertijd-1-2-weken';
    var TEKST = 'Levertijd 1–2 weken voor dit product.';
    var cache = {};
    function tagsOf(handle) {
      if (!cache[handle]) {
        cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return p && p.tags ? p.tags : []; })
          .catch(function () { return []; });
      }
      return cache[handle];
    }
    function melding(id, extra) {
      var d = document.createElement('div');
      d.id = id; d.setAttribute('data-av-levertijd', '');
      d.style.cssText = 'margin:10px 0;padding:10px 12px;border:1px solid #f06018;border-left-width:4px;background:#fff7f1;color:#111418;font-size:13px;line-height:1.4;border-radius:3px';
      d.textContent = extra;
      return d;
    }

    /* productpagina */
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) {
      tagsOf(m[1]).then(function (t) {
        if (t.indexOf(TAG) < 0) return;
        var form = document.querySelector('main form[action*="/cart/add"], form[action*="/cart/add"]');
        if (form && !document.getElementById('av-levertijd-pdp')) {
          form.parentNode.insertBefore(melding('av-levertijd-pdp', TEKST), form);
        }
        var walker = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT, null);
        var n;
        while ((n = walker.nextNode())) {
          if (/Levertijd 1[–-]3 werkdagen/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/Levertijd 1[–-]3 werkdagen/, 'Levertijd 1–2 weken');
        }
      });
    }

    /* winkelwagen (pagina en lade) */
    var timer = null;
    function cartCheck() {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var handles = {};
        (cart.items || []).forEach(function (i) { if (i.handle) handles[i.handle] = true; });
        return Promise.all(Object.keys(handles).map(function (h) { return tagsOf(h); }));
      }).then(function (lijst) {
        var heeft = lijst.some(function (t) { return t.indexOf(TAG) >= 0; });
        var plekken = [
          [document.querySelector('.cart__ctas'), 'av-levertijd-cart'],
          [document.querySelector('.av-drawer__foot'), 'av-levertijd-drawer']
        ];
        plekken.forEach(function (p) {
          var el = document.getElementById(p[1]);
          if (!heeft) { if (el) el.remove(); return; }
          if (!p[0] || el) return;
          p[0].parentNode.insertBefore(melding(p[1], 'Let op: een of meer producten in uw wagen hebben een levertijd van 1–2 weken.'), p[0]);
        });
      }).catch(function () {});
    }
    function plan() { clearTimeout(timer); timer = setTimeout(cartCheck, 500); }
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.closest && (t.closest('[data-av-cart-lines]') || t.closest('.cart-items') || t.closest('cart-items-component'))) { plan(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-av-cart-open]')) plan(); });
    plan();
  }

  function boot() { initMobileSticky(); initFilterToggle(); initMenuToggle(); initNavPanelPlacement(); initLevertijd(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
